import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	CLEAR_LOGIN_ERROR,
} from '../../constants/index';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const authReducer = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_REQUEST:
			return {
				...state,
				loading: true,
				data: null,
				// error: null,
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case LOGIN_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		case CLEAR_LOGIN_ERROR:
			return {
				...state,
				error: null,
				loading: false,
			};
		default:
			return state;
	}
};

export default authReducer;
